import {iFrameConnection} from "./IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {blinkPaymentProcessor} from "../../client/connection/Services";
import {TopUpPaymentStore} from "../State";
import {Dispatchable, Dispatcher} from "../../stem-core/src/base/Dispatcher";
import {Errors} from "../../client/connection/services/Errors";
import {CurrencyStore} from "../State";
import {Logger} from "../Logger";
import {PaymentStore} from "../../client/state/PaymentStore";
import {iFrameMerchantService} from "./IframeMerchantService";


class IFramePaymentsProcessor extends Dispatchable {
    currentArticle = null;
    topUpHandler = null;
    manualPaymentOfferId = null;
    lastPayload = null;

    init() {
        iFrameConnection.addIframesListener(IFrameMessages.MAKE_NEXT_PAYMENT_MANUALLY, ({offerId}) => {
            this.manualPaymentOfferId = offerId;
        });
        iFrameConnection.addIframesListener(IFrameMessages.MANUAL_PAYMENT_REQUEST, ({request}) =>
            this.requestManualConfirmedPayment(request));

        iFrameConnection.addListener(IFrameMessages.PAYMENT_REQUEST, request => {
            if (request.offerId !== this.manualPaymentOfferId) {
                this.requestPayment(request);
                return;
            }
            this.manualPaymentOfferId = null;
            this.requestManualConfirmedPayment(request);
        });
    }

    getErrorLinkByCode(error) {
        const {code, message} = error;

        for (const key of Object.keys(Errors.errorCodes)) {
            if (Errors.errorCodes[key] === code) {
                return Errors.errorLinks[key];
            }
        }

        Logger.log("[Errors] No error link found for error code", code, message);
        return Errors.errorLinks.UNEXPECTED_ERROR;
    }

    enhanceErrorWithLinkField(error) {
        return {
            ...error,
            // TODO: Rename to errorLink
            panelLink: this.getErrorLinkByCode(error),
        }
    }

    requestGenericPayment(backendCall, payload) {
        const merchant = iFrameMerchantService.getMerchant();
        let currencyCodeValue = payload.currencyCode || payload.currencyIsoCode || merchant.getCurrency().getIsoCode();

        const currency = CurrencyStore.getByIsoCode(currencyCodeValue);
        if (payload.amountInSubunits != null) {
            payload.amount = currency.subunitsToAmount(payload.amountInSubunits);
        }
        if (payload.amountInMainUnits != null) {
            payload.amount = currency.mainUnitsToAmount(payload.amountInMainUnits);
        }
        payload.currencyIsoCode = currencyCodeValue;
        payload.currencyCode = currencyCodeValue;
        payload.merchantId = merchant.id;

        this.lastPayload = payload;

        backendCall(payload, response => {
            this.currentArticle = {
                title: payload?.comment?.title,
                purchaseId: PaymentStore.loadFromResponse(response)?.[0]?.id,
            };
            Logger.log("Received manual confirmed payment response from API Client", response);
            iFrameConnection.sendToSDK(IFrameMessages.PAYMENT_RESPONSE, {
                request: payload,
                response,
            });
        }, error => {
            this.currentArticle = null;
            Logger.log("Received error on payment request", error);
            iFrameConnection.sendToSDK(IFrameMessages.PAYMENT_RESPONSE, {
                request: payload,
                error: this.enhanceErrorWithLinkField(error),
            });
        });
    }

    requestManualConfirmedPayment(payload) {
        Logger.log("Received manual confirmed payment request:", payload);
        this.requestGenericPayment((...args) =>
                blinkPaymentProcessor.makePaymentManualConfirmed(...args), payload);
    }

    requestPayment(payload) {
        Logger.log("Received payment request:", payload);
        this.requestGenericPayment((...args) =>
                blinkPaymentProcessor.makePayment(...args), payload);
    }

    clearTopUpHandler() {
        if (this.topUpHandler) {
            this.topUpHandler.remove();
            this.topUpHandler = null;
        }
    }

    remakeLastPaymentAfterFundsAdded() {
        this.clearTopUpHandler();
        this.topUpHandler = this.attachListenerOnce(TopUpPaymentStore, "create", () => {
            this.attachListenerOnce(Dispatcher.Global, "balanceAnimationFinished", () => {
                this.requestManualConfirmedPayment(this.lastPayload);
                this.topUpHandler.remove();
            });
        });
    }
}

export const iFramePaymentsProcessor = new IFramePaymentsProcessor();
